import { BannerCard } from "../banner-card/BannerCard";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import useDesktopChecker from "../../../hooks/useDesktopChecker";
import classNames from "classnames";
import { UQUAL_AD_BANNER_TITLE_DESKTOP,UQUAL_AD_BANNER_TITLE_MOBILE, UQUAL_AD_BANNER_SUBTITLE_DESKTOP,UQUAL_AD_BANNER_SUBTITLE_MOBILE, UQUAL_AD_BANNER_CTA } from "utilities/Constant";
import {
  trackFSUqualBannerDismissed,
  trackFSUqualBannerStartNowClicked,
  UqualFullStoryProps,
} from "utilities/full-story";

export interface UqualAdBannerProps {
    readonly onCTAClick: () => void;
    readonly onDismiss?: () => void;
    readonly className?: string;
    readonly trackingProps?: UqualFullStoryProps;
}

export function UqualAdBanner({ onCTAClick, onDismiss, className, trackingProps }: Readonly<UqualAdBannerProps>) {
    const isDesktop = useDesktopChecker();

    return (
        <BannerCard
            title={isDesktop ? UQUAL_AD_BANNER_TITLE_DESKTOP : UQUAL_AD_BANNER_TITLE_MOBILE}
            subtitle={isDesktop ? UQUAL_AD_BANNER_SUBTITLE_DESKTOP : UQUAL_AD_BANNER_SUBTITLE_MOBILE}
            ctaLabel={UQUAL_AD_BANNER_CTA}
            onCTAClick={() => {
              trackFSUqualBannerStartNowClicked(trackingProps);
              onCTAClick();
            }}
            onDismiss={onDismiss
              ? () => {
                  trackFSUqualBannerDismissed(trackingProps);
                  onDismiss();
                }
              : undefined}
            icon={solid("mobile-alt")}
            variant={isDesktop ? "desktop" : "mobile"}
            className={classNames("uqual-ad-banner", className)}
        />
    );
}

export default UqualAdBanner;